import { ElementCommonPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/element-common-property-converter';
import { FillConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/fill/fill-converter';
import { GroupChildFrameConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/frame/group-child-frame-converter';
import { Element3DConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/3d/element-3d-converter';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IGroupShapeData, DeltaOf, IGroupShapeProps, IDrawingShapeData } from '@tencent/slide-sdk-model';
import { DeepPartial } from 'ts-essentials';
import { LockingConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/locking/locking-converter';
import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';

export class GroupPropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<IGroupShapeProps>,
        uiData: IGroupModel,
    ): void {
        ElementCommonPropertyConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
        if (sdkData.spPr?.xfrm) {
            GroupChildFrameConverter.convertPartialDataFromSdkToUi(sdkData.spPr.xfrm, uiData.props.childFrame);
        }
        if (sdkData?.spPr) {
            // 填充
            if (FillConverter.needConvertSdkData(sdkData.spPr)) {
                // 对齐以前逻辑，每次都重新覆盖一个新对象
                uiData.props.style.fillBackground = {};
                FillConverter.convertPartialDataFromSdkToUi(sdkData.spPr, uiData.props.style.fillBackground);
            }
        }
        // 锁定纵横比
        if (sdkData.nvPr) {
            LockingConverter.convertPartialDataFromSdkToUi(sdkData.nvPr.locking, uiData.props);
        }
        if (sdkData.spPr?.scene3d) {
            uiData.scene3d = uiData.scene3d ?? {};
            Element3DConverter.convertScene3DFromSdkToUi(sdkData.spPr.scene3d, uiData.scene3d);
        } else {
            uiData.scene3d = undefined;
        }
    }

    // eslint-disable-next-line complexity
    public static convertPartialDataFromUiToSdk(
        partialUiData: DeepPartial<IGroupModel>,
        toSdkData: DeltaOf<IGroupShapeData>,
        rawUiData: IGroupModel,
    ): void {
        if (partialUiData.props?.style) {
            ElementCommonPropertyConverter.convertPartialDataFromUiToSdk(partialUiData, toSdkData, rawUiData);

            const style = partialUiData.props?.style;
            toSdkData.spPr = toSdkData.spPr || {};
            // 填充
            if (style?.fillBackground) {
                // @ts-ignore
                FillConverter.convertPartialDataFromUiToSdk(style?.fillBackground, toSdkData.spPr);
            }
        }
        if (partialUiData.props?.childFrame) {
            if (!toSdkData.spPr?.xfrm) {
                toSdkData.spPr = { xfrm: { } };
            }
            const { xfrm } = toSdkData.spPr;
            // @ts-ignore
            GroupChildFrameConverter.convertPartialDataFromUiToSdk(partialUiData.props?.childFrame, xfrm);
        }

        if (partialUiData.children && partialUiData.children.length > 0) {
            const sdkElements: DeltaOf<Array<IDrawingShapeData>> = [];
            for (let i = 0, len = partialUiData.children.length; i < len; i++) {
                const uiElementData = partialUiData.children[i];

                const sdkElementData: DeltaOf<IDrawingShapeData> = {};
                Object.getPrototypeOf(uiElementData).constructor
                    .convertDataUiToSdk(uiElementData, sdkElementData, uiElementData);
                sdkElements.push(sdkElementData);
            }
            toSdkData.shapeList = sdkElements;
        }
        // 锁定纵横比
        if (partialUiData.props?.[Locks.LOCKS]) {
            toSdkData.nvPr = toSdkData.nvPr || {};
            toSdkData.nvPr.locking = toSdkData.nvPr.locking || {};
            LockingConverter.convertPartialDataFromUiToSdk(partialUiData.props, toSdkData.nvPr.locking);
        }
        // 3d
        toSdkData.spPr = toSdkData.spPr || {};
        if (partialUiData.props?.scene3d) {
            toSdkData.spPr.scene3d = toSdkData.spPr.scene3d ?? {};
            Element3DConverter.convertScene3DFromUiToSdk(partialUiData.props.scene3d, toSdkData.spPr.scene3d);
        } else if (partialUiData.props?.scene3d === null) {
            toSdkData.spPr.scene3d = null;
        }
    }
}
